/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Bills_List_Empty_DescriptionInputs */

const es_admin_billing_bills_list_empty_description = /** @type {(inputs: Admin_Billing_Bills_List_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay facturas registradas aún.`)
};

const en_admin_billing_bills_list_empty_description = /** @type {(inputs: Admin_Billing_Bills_List_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No invoices have been recorded yet.`)
};

/**
* | output |
* | --- |
* | "No invoices have been recorded yet." |
*
* @param {Admin_Billing_Bills_List_Empty_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_empty_description = /** @type {((inputs?: Admin_Billing_Bills_List_Empty_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_Empty_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_empty_description(inputs)
	return en_admin_billing_bills_list_empty_description(inputs)
});
export { admin_billing_bills_list_empty_description as "admin.billing.bills_list.empty_description" }